import { render, staticRenderFns } from "./actionbar.vue?vue&type=template&id=06354499&lang=pug"
import script from "./actionbar.vue?vue&type=script&lang=js"
export * from "./actionbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports